import script from "./MainNavbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./MainNavbar.vue?vue&type=script&setup=true&lang=ts"

import "./MainNavbar.vue?vue&type=style&index=0&id=42ebe466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-42ebe466"]])

export default __exports__